import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

export type EmtTooltipProps = TooltipProps & { nonce?: string };

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#34303E",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    padding: "8px 14px",
    borderRadius: "10px",
    backgroundColor: "#34303E",
  },
}));

export function EmtTooltip(props: EmtTooltipProps) {
  return <StyledTooltip enterTouchDelay={50} leaveTouchDelay={0} {...props} />;
}
